document.addEventListener("DOMContentLoaded", function () {
  const buyButtons = document.querySelectorAll('form[action^="/cart"] [type="submit"], .product-form__submit, button[name="add"]');

  buyButtons.forEach(button => {
    button.addEventListener("click", function () {
      const cepField = document.querySelector('[name="zipcode"], [id*="cep"]');
      const addressField = document.querySelector('input[name="address1"], input[name="checkout[shipping_address][address1]"]');

      if (cepField && addressField && cepField.value === addressField.value) {
        addressField.value = "";
      }
    });
  });
});
